import { Link } from "react-router-dom";
import { Instagram } from "lucide-react";

export default function Footer() {
  return (
    <footer className="border-t border-ink-700 mt-32" data-testid="site-footer">
      <div className="max-w-7xl mx-auto px-6 md:px-12 py-16 grid grid-cols-1 md:grid-cols-12 gap-10">
        <div className="md:col-span-5">
          <div className="font-serif-display text-3xl text-paper leading-tight">
            Paco<br />Revueltas
          </div>
          <p className="mt-2 eyebrow">Estudio Sombra · Fotografía</p>
          <p className="mt-4 text-paper-dim font-light max-w-sm">
            Retratos, foto de calle y arquitectura. Imágenes silenciosas que cuentan historias.
          </p>
          <a
            href="https://www.instagram.com/pacorevueltas/"
            target="_blank"
            rel="noreferrer noopener"
            className="mt-6 inline-flex items-center gap-2 font-mono-ed text-[0.72rem] tracking-[0.22em] uppercase text-paper-dim hover:text-paper transition-colors border-b border-transparent hover:border-paper pb-1"
            data-testid="footer-instagram"
          >
            <Instagram size={14} strokeWidth={1.5} />
            @pacorevueltas
          </a>
        </div>
        <div className="md:col-span-3">
          <div className="eyebrow mb-4">Navegar</div>
          <ul className="space-y-2 font-light text-paper">
            <li><Link to="/" className="hover:underline">Inicio</Link></li>
            <li><Link to="/galeria" className="hover:underline">Galería</Link></li>
            <li><Link to="/contacto" className="hover:underline">Contacto</Link></li>
          </ul>
        </div>
        <div className="md:col-span-4">
          <div className="eyebrow mb-4">Sígueme</div>
          <a
            href="https://www.instagram.com/pacorevueltas/"
            target="_blank"
            rel="noreferrer noopener"
            className="group flex items-center gap-3 font-light text-paper hover:text-paper-dim transition-colors"
            data-testid="footer-instagram-2"
          >
            <span className="w-10 h-10 border border-ink-700 grid place-items-center group-hover:border-paper transition-colors">
              <Instagram size={16} strokeWidth={1.5} />
            </span>
            <span>
              <span className="block">Instagram</span>
              <span className="block font-mono-ed text-xs text-paper-mute">@pacorevueltas</span>
            </span>
          </a>
          <p className="mt-6 font-mono-ed text-xs text-paper-mute">© {new Date().getFullYear()} Paco Revueltas · Estudio Sombra</p>
        </div>
      </div>
    </footer>
  );
}
